import { Helmet } from 'react-helmet';
import '../../../styles/dashboardStyles.css';
import Header from '../../../components/header';
import Navbar from '../../../components/NavBar';
import { GetOnBaseDocumentsRequest } from '../types/GetOnBaseDocumentsRequest';
import OnBaseDeletedDocumentsTable from '../components/OnBaseDeletedDocumentsTable';
import { useState } from 'react';
import useGetOnBaseDocuments from '../hooks/useGetOnBaseDocuments';
import { OnBaseDocumentData } from '../types/OnBaseDocumentData';
import DeleteFailedDocument from '../api/DeleteFailedDocument';
import '../../../styles/dashboardStyles.css';

function OnBaseDeletedDocumentsPage() {

  let paramvalues: GetOnBaseDocumentsRequest = {
    rowKey: "",
    partitionKey: "ToOnBase",
    MaxRetries: 5,
    OnBaseReceived: false,
    IsDeleted: true
  }

  const [RefreshFlag, setRefreshFlag] = useState(0);
  const { Data, loading } = useGetOnBaseDocuments(paramvalues, RefreshFlag);

  function handleUnDeleteDocument(doc: OnBaseDocumentData) {
    DeleteFailedDocument(doc)
    setRefreshFlag((prev) => prev + 1)
  }

  return (
    <>
      <div className="full-height-form p-fluid">
        <Helmet>
          <title>OnBase Deleted Documents</title>
        </Helmet>
        <Header />
        <Navbar />
        <h1 className='Ph1'>OnBase Deleted Documents</h1>
        <OnBaseDeletedDocumentsTable DataList={Data} handleUnDeleteDocument={handleUnDeleteDocument} />
      </div>

    </>
  )
}

export default OnBaseDeletedDocumentsPage
